import React, { useState, useEffect, useRef } from "react";
import { Grid, InputLabel, makeStyles } from "@material-ui/core";
import Select from "react-select";
import getSymbolFromCurrency from "currency-symbol-map";
import { GetCookies } from "../../../_helpers/Cookies";
import { validateInput } from "../../../_helpers/validationHelper";
import { InputField } from "../../ccmode2.0/CcmodeSetupNew/FormFields";

const useStyles = makeStyles((theme) => ({
    textField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "4px !important",
        },
        "& .MuiInputBase-input.Mui-disabled": {
            borderRadius: "4px",
            height: "0px",
        },
    },
}));

export default function TaxForm(props) {
    const classes = useStyles();

    const {
        formField: { muti_currency, tax_value, tax_name },
        values,
        setFieldValue,
        language,
        feedsetting,
    } = props;

    const taxSectionRef = useRef(null);

    useEffect(() => {
        if (values.taxinclusive && taxSectionRef.current) {
            taxSectionRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [values.taxinclusive]);

    const [currencyDropdown, setCurrencyDropdown] = useState([]);

    useEffect(() => {
        let isMounted = true; // ← track mounting status

        async function fetchConversionRates() {
            try {
                const response = await GetCookies("conversionrates");
                if (!isMounted) return; // ← bail out if unmounted

                // only proceed if you got a non‐empty cookie
                if (response && response[0]) {
                    const currencies = JSON.parse(response)[0];

                    const options = Object.entries(currencies)
                        .filter(
                            ([key]) =>
                                key.startsWith("cur_") && !key.includes("org")
                        )
                        .map(([key, rate]) => {
                            const code = key.split("_")[1].toUpperCase();
                            const symbol = getSymbolFromCurrency(code);
                            return {
                                value: code,
                                label: `${code} ${symbol} - ${(
                                    Math.round(rate * 100) / 100
                                ).toFixed(2)}`,
                            };
                        });

                    setCurrencyDropdown(options);
                }
            } catch (err) {
                console.error("Failed to load conversion rates:", err);
            }
        }

        fetchConversionRates();

        return () => {
            // cleanup: mark as unmounted so any in-flight promise won’t call setState
            isMounted = false;
        };
    }, []);
    const SetTaxInclusive = (values) => {
        props.setFieldValue("taxinclusive", !values.taxinclusive);
    };

    const handleInputChange = (name, value) => {
        if (validateInput(value)) {
            props.setFieldValue(name, value);
        }
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} className="mt-6">
                <Grid
                    container
                    spacing={3}
                    alignItems="flex-start"
                    justify="space-between"
                >
                    <Grid item xs={8} md={4}>
                        <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                            Show Display Price
                            <span className="small d-block mt-2 line-height-lg">
                                Toggle to show or hide product prices.
                            </span>
                        </InputLabel>
                    </Grid>
                    <Grid item>
                        <label className="switch">
                            <input
                                type="checkbox"
                                className="success"
                                checked={!values?.noprice}
                                value={values?.noprice}
                                onChange={() => {
                                    props.setFieldValue(
                                        "noprice",
                                        !values.noprice
                                    );
                                    setFieldValue("noprice", !values.noprice);
                                }}
                            />
                            <span className="slider" />
                        </label>
                    </Grid>
                </Grid>
            </Grid>
            <hr className="w-100" />
            <Grid item xs={12} className="my-6">
                <Grid
                    container
                    spacing={3}
                    alignItems="flex-start"
                    justify="space-between"
                >
                    <Grid item xs={12} md={4}>
                        <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                            Default Currency
                            <span className="small d-block mt-2 line-height-lg">
                                Choose the currency that will be shown by
                                default.
                            </span>
                        </InputLabel>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Select
                            name={muti_currency.name}
                            options={currencyDropdown}
                            value={currencyDropdown.filter((option) =>
                                values.muti_currency.includes(option.value)
                            )}
                            onChange={(opts) => {
                                props.setFieldValue(
                                    muti_currency.name,
                                    opts.value
                                );
                                setFieldValue(muti_currency.name, opts.value);
                            }}
                            placeholder="Select default currency"
                        />
                    </Grid>
                </Grid>
            </Grid>
            {!values.hidePrice && (
                <>
                    <Grid item xs={12} className="my-6">
                        <Grid
                            container
                            spacing={3}
                            alignItems="flex-start"
                            justify="space-between"
                        >
                            <Grid item xs={8} md={4}>
                                <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                    Tax Settings
                                    <span className="small d-block mt-2 line-height-lg">
                                        Choose whether tax is added as{" "}
                                        <b>inclusive</b> or <b>exclusive</b> of
                                        tax.
                                    </span>
                                </InputLabel>
                            </Grid>
                            <Grid item>
                                <label className="switch ">
                                    <input
                                        type="checkbox"
                                        className="success"
                                        defaultChecked={values.taxinclusive}
                                        value={values.taxinclusive}
                                        onClick={() => SetTaxInclusive(values)}
                                    />
                                    <span className="slider"></span>
                                </label>
                            </Grid>
                        </Grid>
                    </Grid>
                    {values.taxinclusive ? (
                        <>
                            <Grid
                                item
                                xs={12}
                                className="my-6"
                                ref={taxSectionRef}
                            >
                                <Grid
                                    container
                                    spacing={3}
                                    alignItems="flex-start"
                                    justify="space-between"
                                >
                                    <Grid item xs={12} md={4}>
                                        <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                            Tax Label
                                            <span className="small d-block mt-2 line-height-lg">
                                                Enter a name or label for the
                                                tax (e.g., VAT, GST).
                                            </span>
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <InputField
                                            className={classes.textField}
                                            name={tax_name.name}
                                            fullWidth
                                            InputProps={{
                                                style: {
                                                    height: "40px",
                                                },
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className="my-6">
                                <Grid
                                    container
                                    spacing={3}
                                    alignItems="flex-start"
                                    justify="space-between"
                                >
                                    <Grid item xs={12} md={4}>
                                        <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                            Tax Rate
                                            <span className="small d-block mt-2 line-height-lg">
                                                Define the applicable tax
                                                percentage.
                                            </span>
                                        </InputLabel>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <InputField
                                            className={classes.textField}
                                            name={tax_value.name}
                                            fullWidth
                                            value={props.values.tax_value || ""}
                                            InputProps={{
                                                style: {
                                                    height: "40px",
                                                },
                                            }}
                                            onChange={(e) =>
                                                handleInputChange(
                                                    e.target.name,
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    ) : (
                        ""
                    )}
                </>
            )}
        </Grid>
    );
}
